import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  applyActionCode,
  confirmPasswordReset,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { auth } from "../firebase";

const AuthAction = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mode, setMode] = useState("");
  const [message, setMessage] = useState("");
  const [verificationEmail, setVerificationEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordCheck, setPasswordCheck] = useState("");
  const [showResendVerification, setShowResendVerification] = useState(false);
  const [isResendingVerificationEmail, setIsResendingVerificationEmail] =
    useState(false);
  const [isResettingPassword, setIsResettingPassword] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode") || "";
    const actionCode = queryParams.get("oobCode");
    const continueUrl = queryParams.get("continueUrl");
    setMode(mode);

    // const auth = getAuth();

    switch (mode) {
      case "resetPassword":
        setMessage("Please enter a new password.");
        break;
      case "recoverEmail":
        // Implement handleRecoverEmail logic here
        setMessage("Recover your email.");
        break;
      case "verifyEmail":
        if (actionCode) {
          applyActionCode(auth, actionCode)
            .then(() => {
              setMessage(
                "Email verified successfully! You can now sign in.<br /><br />Redirecting you now..."
              );
              setTimeout(() => navigate(continueUrl || "/"), 3000);
            })
            .catch(() => {
              setMessage(
                "Error verifying email. The verification code is invalid or expired."
              );
              setShowResendVerification(true);
              // setTimeout(() => navigate("/"), 5000);
            });
        }
        break;
      default:
        navigate("/");
      // setMessage("Invalid request. Please check the link and try again.");
    }
  }, [location, navigate]);

  const checkPasswordsMatch = () => {
    const password = (
      document.getElementsByName("password")[0] as HTMLInputElement
    ).value;
    const confirmPassword = (
      document.getElementsByName("confirmPassword")[0] as HTMLInputElement
    ).value;
    setConfirmPassword(confirmPassword);
    if (password === confirmPassword) {
      setPasswordCheck("true");
    } else {
      setPasswordCheck("false");
    }
  };

  const handleResendVerificationEmail = async () => {
    setIsResendingVerificationEmail(true);
    try {
      const user = auth.currentUser;
      if (user) {
        await sendEmailVerification(user);
        setMessage("Verification email sent. Please check your inbox.");
      } else {
        setMessage(
          "Error sending verification email. Please attempt to sign in again and request to resend a new verification email. <br /><br />Redirecting you now..."
        );
        setTimeout(() => navigate("/"), 5000);
      }
    } catch (error) {
      setMessage("Error sending verification email.");
    }
  };

  const handlePasswordReset = async () => {
    setIsResettingPassword(true);
    if (newPassword !== confirmPassword) {
      setPasswordCheck("false");
      return;
    }
    if (newPassword.length < 6) {
      setMessage("Password must be at least 6 characters long.");
      return;
    }

    const actionCode = new URLSearchParams(location.search).get("oobCode");
    // const auth = getAuth();
    if (actionCode === null) {
      setMessage("Error resetting password. Invalid action code.");
      return;
    }
    try {
      await confirmPasswordReset(auth, actionCode, newPassword);
      alert("Password reset successfully. Please login with your new password.");
      setMessage(
        "Password reset successfully. Please login with your new password. <br /><br /> Redirecting you now..."
      );
      await signOut(auth);
      navigate("/");
      // setTimeout(() => navigate("/"), 3000);
      // setIsResettingPassword(false);
    } catch (error) {
      setMessage("Error resetting password.");
      setIsResettingPassword(false);
    }
  };

  return (
    <div className="box-sizing-default auth-action-container">
      <div className="box-sizing-default images" id="welcome-logo-image"></div>
      <h2>
        {mode === "verifyEmail" ? "Email Verification" : "Reset Password"}
      </h2>
      <p
        style={{ textAlign: "center" }}
        dangerouslySetInnerHTML={{ __html: message }}
      ></p>
      {mode === "resetPassword" && (
        <div className="box-sizing-default auth-action-form">
          <label className="box-sizing-default" style={{ textAlign: "left" }}>
            New Password
          </label>
          <input
            className="box-sizing-default"
            type="password"
            name="password"
            placeholder="Enter your new password"
            value={newPassword}
            disabled={isResettingPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            required
          />
          {newPassword.length < 6 && newPassword.length > 0 && (
            <div
              className="box-sizing-default alert-text"
              style={{ marginTop: "-18px" }}
            >
              Password must be at least 6 characters long
            </div>
          )}
          <label className="box-sizing-default">Confirm Password</label>
          <input
            className="box-sizing-default"
            type="password"
            name="confirmPassword"
            placeholder="Confirm your password"
            disabled={isResettingPassword}
            required
            onChange={checkPasswordsMatch}
          />
          {passwordCheck === "false" && (
            <div
              className="box-sizing-default alert-text"
              style={{ marginTop: "-18px" }}
            >
              Passwords do not match
            </div>
          )}
          <button
            type="submit"
            className="button-primary"
            style={{ marginTop: "20px", marginBottom: "20px" }}
            disabled={
              !passwordCheck || newPassword.length < 6 || isResettingPassword
            }
            onClick={handlePasswordReset}
          >
            Reset Password
          </button>
        </div>
      )}

      {/* Recover Email UI can be added here */}
      {showResendVerification && (
        <>
          <button
            className="button-primary"
            style={{ width: "auto", marginTop: "1rem" }}
            disabled={isResendingVerificationEmail}
            onClick={handleResendVerificationEmail}
          >
            Resend Verification Email
          </button>
        </>
      )}
    </div>
  );
};

export default AuthAction;
